import {equals, type} from "@codeArt/utils/common";
import React, { useEffect } from "react";

export function createIcon(icon, className, p){
  if (!icon) return null;
  const Icon = icon;
  return <Icon className={className} {...p} />;
}

export function Empty({text,label, className, textClassName, align}){
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-${align} c-text-grey p-4 c-h-fill ${textClassName} ${className}`}
    >
      {text || label || "暂无数据"}
    </div>
  );
}

Empty.defaultProps = {
  className: "",
  textClassName: "c-text-s3",
  align: "center"
};

export function EmptySlim({className, label, gap}){
  return <p className={`my-${gap} m-text-muted ${className}`}>{label}</p>;
}

EmptySlim.defaultProps = {
  gap: 3,
  label: "暂无数据",
  className: "c-text-s2"
};

export function getNotificationMessage(msg){
  let _type = type(msg);
  if (_type === "string") return msg;
  if (_type === "array")
    return (
      <div>
        {msg.map((m, i) => (
          <p key={i} className="c-notification">
            {m}
          </p>
        ))}
      </div>
    );
  if (_type === "object") {
    if (msg.stack) return msg.stack;
    if (msg.toString) return msg.toString();
    return JSON.stringify(msg);
  }
}

export function changed(prevProps, nextProps, props){
  props = props || [];
  for (let i = 0; i < props.length; i++) {
    let name = props[i];
    if (!equals(prevProps[name], nextProps[name])) return true;
  }
  return false;
}

export function memo(prevProps, nextProps, props){
  //根据属性的改变，判断是否需要记忆
  return !changed(prevProps, nextProps, props);
}



export class AsyncComponent extends React.Component {  //组件内部有异步操作
  constructor(props) {
    super(props);
    this._life = true;
  }

  setState(state,callback){
    if(!this._life) return;
    super.setState(state,callback);
  }

  componentWillUnmount(){
    this._life= false;
  }

}
